"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var populated_1 = require("utils/selectors/populated");
var context_1 = __importDefault(require("./context"));
var tableConf_1 = require("./tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.impersonateTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.impersonateTableConf);
var ImpersonateTable = function (_a) {
    var company = _a.company;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'public_users', where: ['companyIds', 'array-contains', company.id], storeAs: "".concat(company.id, "Users") },
    ]; });
    var users = (0, react_redux_1.useSelector)((0, populated_1.makeSelectPopulatedCompanyUsers)(company.id));
    if (!(0, react_redux_firebase_1.isLoaded)(users)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    if (users.length === 0) {
        return (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ textAlign: "center", width: 980 }, { children: "No users found" }));
    }
    return ((0, jsx_runtime_1.jsx)(context_1.default.Provider, __assign({ value: company.id }, { children: (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 980, height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(Header, { maxWidth: 980 }), (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, __assign({ viewStyle: { minHeight: 100, maxHeight: 500, position: 'inherit' } }, { children: (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: users.map(function (user) { return (0, jsx_runtime_1.jsx)(Row, { item: user }, user.id); }) }) }))] })) })));
};
exports.default = ImpersonateTable;
